// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cOs88","type":"styles_type__2E3-N","choices":"styles_choices__2xHx1"};